<script>
import { mapActions } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import RbxRemoteCombobox from '../../shared/reybex/RbxRemoteCombobox';
import History from '../history';

export default {
  name: 'ResellerAgent',
  components: {
    RbxRemoteCombobox,
    History,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      user: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/resellerAgent/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('resellerAgent', ['fetchResellerAgent', 'saveResellerAgent']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchResellerAgent(this.params.id)
        .then(({ data }) => {
          console.log(data);
          this.user = data;

          this.updateTabTitle({ path: this.path, title: this.user.username });
        })
        .catch((err) => {
          console.log(err);
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      return this.saveResellerAgent(this.user)
        .then(() => {
          this.showSuccessMessage('Die Vertretung wurde erfolgreich gespeichert!');
        })
        .catch((err) => {
          let errorMessage;

          try {
            errorMessage = err.response.data.data.error;
          } catch (e) {
            return e;
          }

          return this.showErrorMessage(errorMessage || 'Die Vertretung konnte nicht gespeichert werden. Bitte versuche es erneut!');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<template>
  <div class="user-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching user information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>
      </v-toolbar>

      <v-tabs v-model="activeTab"
              height="35"
              slider-color="black"
              color="amber">
        <v-tab ripple>Stammdaten</v-tab>
        <v-tab ripple>Historie</v-tab>

        <v-tab-item>
          <form>
            <v-container fluid grid-list-lg pt-2 pa-0>
              <v-layout row wrap>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.username"
                    label="Benutzername"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.password"
                    label="Neues Passwort"
                    height="22"
                    class="caption"
                    type="password"
                  />
                </v-flex>

                <v-flex xs12 md12 py-0>&nbsp;</v-flex>

                <v-flex xs6 md4 py-0>
                  <rbx-remote-combobox
                    v-model="user.salutation"
                    label="Anrede"
                    :selected="user.salutation"
                    domain="salutation"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.firstname"
                    label="Vorname"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.surname"
                    label="Nachname"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.phone"
                    label="Telefon"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.mobile"
                    label="Handy"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.fax"
                    label="Fax"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.email"
                    label="E-Mail-Adresse"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12 py-0>&nbsp;</v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.street"
                    label="Straße"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md2 py-0>
                  <v-text-field
                    v-model="user.zipcode"
                    label="PLZ"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs6 md2 py-0>
                  <v-text-field
                    v-model="user.city"
                    label="Stadt"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12 py-0>&nbsp;</v-flex>

                <v-flex xs6 md4 py-0>
                  <v-text-field
                    v-model="user.department"
                    label="Abteilung"
                    height="22"
                    class="caption"
                  />
                </v-flex>

              </v-layout>
            </v-container>
          </form>
        </v-tab-item>
        <v-tab-item>
          <History :domain="'user'" :domain-id="user.id" path="/history" />
        </v-tab-item>
      </v-tabs>
    </template>
  </div>
</template>
